import { BrandModelData } from '../../empracoTypes';
import { render } from '../../main';

export type LangId =
  'sv-SE' |
  'en-GB' |
  'en-US' |
  'de-DE' |
  'nb-NO';

export const brandPagesTranslations = {
  'sv-SE': {
    model: 'Modell',
    year: 'År',
    link: 'Sidlänk',
    seeAllModels: 'Se alla modeller'
  },
  'en-GB': {
    model: 'Model',
    year: 'Year',
    link: 'Page link',
    seeAllModels: 'See all models'
  },
  'en-US': {
    model: 'Model',
    year: 'Year',
    link: 'Page link',
    seeAllModels: 'See all models'
  },
  'de-DE': {
    model: 'Modell',
    year: 'Jahr',
    link: 'Seitenlink',
    seeAllModels: 'Alle Modelle ansehen'
  },
  'nb-NO': {
    model: 'Modell',
    year: 'År',
    link: 'Sidelenke',
    seeAllModels: 'Se alle modellene'
  }
};

function input(label: string, value: string, hidden?: boolean) {
  return(
    <div className={`form-node node-text node-width-half ${hidden ? 'node-hidden' : 'node-visible'}`}>
      <p className='form-label-text'>{label}</p>
      <input
        type='text'
        value={value}
        name={`${label} (auto)`}
        id={`${label} (auto)`}
        onChange={_ => null} />
    </div>
  );
}

function modelInfo(data: BrandModelData): JSX.Element {
  return(
    <>
      {data.title && input(brandPagesTranslations[data.lang as LangId].model, data.title)}
      {data.year && input(brandPagesTranslations[data.lang as LangId].year, data.year)}
      {data.link && input(brandPagesTranslations[data.lang as LangId].link, data.link, true)}
    </>
  );
}

// Attempts to add additional input fields to the first found form on the page.
export default function alterBrandModelForm(data: BrandModelData) {

  // Attempt to get all forms on brand model page.
  const form = document.querySelectorAll('form')[0];

  if (!form) {
    return;
  }

  // Attempt to get the submit button node.
  const insertRef = form.querySelector('input[type=submit]')?.parentElement;

  if (!insertRef) {
    return;
  }

  // Ok to insert a new element before the submit button node.
  const reactRef = document.createElement('div');
  reactRef.classList.add(...['empori-brand-model-info', 'element-flex']);

  form.insertBefore(reactRef, insertRef);

  // Use React to render the additional form inputs.
  render(modelInfo(data), reactRef);
}